import { forwardRef, type Ref, type SVGProps } from "react";
const IconTextAlignCenterFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M4 6h24a2 2 0 0 0 0-4H4a2 2 0 0 0 0 4m3.5 4a2 2 0 0 0 0 4h17a2 2 0 0 0 0-4ZM28 18H4a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4m-6.5 8h-11a2 2 0 0 0 0 4h11a2 2 0 0 0 0-4" />
  </svg>
);
const ForwardRef = forwardRef(IconTextAlignCenterFilledSVG);
ForwardRef.displayName = "IconTextAlignCenterFilled";
export { ForwardRef as IconTextAlignCenterFilled };
